import React, { useRef, useEffect } from 'react'
import Countdown, { formatTimeDelta, CountdownRenderProps, CountdownProps } from 'react-countdown'
import { Flex, Text } from 'vvs-uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { isNilOrUndef } from 'utils/isNilOrUndef'

const CountDownWrapper = styled.div`
  position: relative;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  width: 280px;
  z-index: 11;
  margin-top: 46px;
  transform: scale(0.9) translate(-24px, -20px);
  ${({ theme }) => theme.mediaQueries.sm} {
    transform: scale(1) translate(0, 0);
  }
  .time {
    font-size: 30px;
    font-weight: bold;
    span {
      display: inline-block;
      width: 32px;
    }
  }
  .time-text {
    text-transform: uppercase;
    font-size: 12px;
    margin-top: 6px;
  }
`

interface LaunchCountDownProps {
  className?: string
  timestamp?: string
  title?: string | React.ReactNode
  countdownProps?: CountdownProps
  disabled?: boolean
}

const StyledI = styled.i`
  flex: 1;
  text-align: center;
`
const LaunchCountDown: React.FC<LaunchCountDownProps> = ({
  className = '',
  timestamp,
  title = 'Launching soon',
  countdownProps,
  disabled,
}) => {
  const { t } = useTranslation()
  const launchTimeStamp = isNilOrUndef(timestamp) ? new Date().getTime() : new Date(timestamp).getTime()
  const ref = useRef<Countdown>()
  const renderer = (time: CountdownRenderProps) => {
    const { days, hours, minutes, seconds } = formatTimeDelta(time)
    return (
      <>
        <Flex className="time" justifyContent="space-around">
          {disabled ? (
            <>
              <span>--</span>:<span>--</span>:<span>--</span>:<span>--</span>
            </>
          ) : (
            <>
              <span>{days}</span>:<span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span>
            </>
          )}
        </Flex>
        <Flex className="time-text">
          <StyledI>{t('Days')}</StyledI>
          <StyledI>{t('Hours')}</StyledI>
          <StyledI>{t('Minutes')}</StyledI>
          <StyledI>{t('Seconds')}</StyledI>
        </Flex>
      </>
    )
  }

  useEffect(() => {
    if (!launchTimeStamp) return
    ref?.current?.start()
  }, [launchTimeStamp])

  return (
    <CountDownWrapper className={className}>
      <Text textTransform="uppercase" fontSize="20px" color="white">
        {title}
      </Text>
      <Countdown {...countdownProps} date={launchTimeStamp} renderer={renderer} ref={ref} />
    </CountDownWrapper>
  )
}

export default LaunchCountDown
